import React from 'react'
import { Layout } from 'ui/layout/Layout'
import { AppBarAdmin } from 'ui/partials/AppBar'
import AdminContentWrapper from 'ui/layout/AdminContentWrapper'
import AdminSidebar from 'ui/partials/AdminSidebar'
import type { AdminSidebarSelectRouteProps } from 'ui/partials/AdminSidebar'
import type { SettingsSubmenuProps } from './SettingSubmenu'
import type { InformationToMed, MedicalInstitutionProps } from 'types/med'
import SettingSubmenu from './SettingSubmenu'

export type MedicalSettingProps = {
  // 医療機関設定
  med: MedicalInstitutionProps
  // サイドバーでのページ切り替え
  selectRoute: AdminSidebarSelectRouteProps
  // サイドバーでのページ切り替え
  settingSubmenu?: SettingsSubmenuProps
  children: any
  controlBar?: any
  update?: InformationToMed
}

const Setting: React.FC<MedicalSettingProps> = ({
  med,
  selectRoute,
  settingSubmenu,
  children,
  controlBar,
  update,
}: MedicalSettingProps) => {
  const sidebarContent = (
    <AdminSidebar med={med} selectRoute={selectRoute}>
      {settingSubmenu && (
        <SettingSubmenu
          generalMenu={settingSubmenu.generalMenu}
          department={settingSubmenu.department}
        />
      )}
    </AdminSidebar>
  )

  return (
    <Layout header={<AppBarAdmin update={update} />}>
      <AdminContentWrapper sidebar={sidebarContent} controlBar={controlBar}>
        {children}
      </AdminContentWrapper>
    </Layout>
  )
}
export default Setting
